import { useEffect, useState } from "react";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
  Legend,
} from "recharts";


const COLORS = ["#dc143c", "#22c55e", "#facc15"]; // yellow, blue, green

const useWindowWidth = () => {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return width;
};

const DoughnutChart = ({combinedData}) => {
  // If you want to use combinedData to dynamically generate the data array
  // you can do so here. For now, using static data.
  const width = useWindowWidth();
  const data = combinedData.reduce((acc, cur) => {
    const status = cur.droneSprayStatus || "Unknown";
    const existing = acc.find((item) => item.name === status);
    if (existing) {
      existing.value += 1;
    }
    else {
      acc.push({ name: status, value: 1 });
    }
    return acc;
  }, []);

  const total = data.reduce((acc, cur) => acc + cur.value, 0);

  const completedValue =
    data.find((item) => item.name === "Completed")?.value || 0;

  const completedPercentage = total
    ? Math.round((completedValue / total) * 100)
    : 0;


  const renderCustomizedLabel = ({
      cx, cy, midAngle, innerRadius, outerRadius, percent, index, name, value
    }) => {
      const RADIAN = Math.PI / 180;
      const radius = outerRadius + 30;
      const x = cx + radius * Math.cos(-midAngle * RADIAN);
      const y = cy + radius * Math.sin(-midAngle * RADIAN);

      return (
        <text
          x={x}
          y={y}
          fill="#333"
          textAnchor="middle"
          dominantBaseline="central"
          fontSize={12}
        >
          {`${name} ${value}`}
        </text>
      );
    };


  return (
    <div className="bg-white mt-2 p-4 rounded-xl shadow md:w-[35%] relative w-[100%]">
      <div className="mb-2">
        <h2 className="text-lg font-bold text-gray-800">Spray Coverage Overview</h2>
        <p className="text-sm text-gray-500">Distribution of area <b>completed</b>, <b>ongoing</b> and <b>pending</b> spraying in percentage</p>
      </div>
      <div className="relative h-[300px]">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              dataKey="value"
              nameKey="name"
              innerRadius={width <= 700 ? 45 : 50}
              outerRadius={width <= 700 ? 70 : 90}
              startAngle={90}
              endAngle={-270}
              labelLine={false}
              // label={renderCustomizedLabel}
            >
              {data.map((entry, index) => (
                <Cell key={index} fill={COLORS[index]} cornerRadius={10} />
              ))}
            </Pie>
            <Tooltip />
          </PieChart>
        </ResponsiveContainer>

        {/* Center Label */}
        <div className="absolute inset-0 flex flex-col items-center justify-center text-black pointer-events-none">
          <span className="text-2xl font-bold">
            {completedPercentage}%
          </span>
          <span className="text-sm text-gray-600">
            Area Covered
          </span>
        </div>
      </div>

    </div>
  );
};

export default DoughnutChart;
